import { userMapper } from '../mappers/user-mapper';
import { apiClient } from '../shared/api-client';
import { logError } from '../shared/error-logger';
import { getMockUserProfile, isMockTestSession, saveMockOnboardingStep } from '../shared/mock-test-user';

const userRepository = {
    async get() {
        if (isMockTestSession()) {
            return userMapper.toDomain(getMockUserProfile());
        }

        const data = await apiClient.get({
            url: 'users/profile'
        });

        return userMapper.toDomain(data);
    },

    async delete() {
        if (isMockTestSession()) {
            return {};
        }

        return apiClient.post({
            url: 'users/delete'
        });
    },

    async getGeo() {
        const data = await apiClient.get({
            url: 'users/geo'
        });

        return data;
    },

    async saveOnboarding(body) {
        if (isMockTestSession()) {
            saveMockOnboardingStep(body);

            return true;
        }

        try {
            await apiClient.post({
                url: 'users/onboarding',
                body
            });

            return true;
        } catch (error) {
            logError(error);

            return false;
        }
    },

    async patch(body) {
        if (isMockTestSession()) {
            return true;
        }

        try {
            await apiClient.patch({
                url: 'users',
                body
            });

            return true;
        } catch (error) {
            logError(error);

            return false;
        }
    }
};

export {
    userRepository
};
